import { Grid } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { routes } from "schemas/routes";
import { HOME_BODY_COLOR } from "styles/oneOffColor";

import Loading from "components/Loading";
import { BRAND_PAGE_VISITED } from "constants/trackingProps";
import { trackEvent } from "utils/tracking";
import { useLogin } from "utils/useLogin";

import { AuthAction } from "../schema";
import BrandOnboardingSignup from "./Signup";

const styles = {
  root: {
    backgroundColor: HOME_BODY_COLOR,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    position: "fixed",
    overflowY: "auto",
    px: { xs: 0, sm: 3, md: 5, lg: 20 },
    py: { xs: 0, sm: 2, md: 5 },
    opacity: 1,
    backgroundSize: "22px 22px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  formContainer: {
    borderRadius: { xs: 0, sm: 4 },
    backgroundColor: HOME_BODY_COLOR,
    maxWidth: { lg: "1024px" },
    p: { xs: 3, sm: 5, md: 8 },
  },
  textField: {
    backgroundColor: "white",
    "& .MuiInputBase-root": { backgroundColor: "white" },
    "& .MuiFormHelperText-root": { color: "error.main" },
  },
  helperText: {},
};

const BrandOnboardingFlow = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchUserInfo, fetchUserLoading, setFetchUserLoading } = useLogin();

  const emailMatch = location.search?.match(/email=([^&]*)/);
  const email = emailMatch ? decodeURIComponent(emailMatch[1]) : "";

  const redirectToPage = async () => {
    setFetchUserLoading(true);
    if (currentOrg?.id) {
      navigate(`/${routes.home}${location.search}`, {
        replace: true,
      });
    } else {
      navigate(`/brands/sign-up${location.search}`, {
        replace: true,
      });
    }
    setFetchUserLoading(false);
  };

  useEffect(() => {
    if (currentOrg?.id) {
      redirectToPage();
    } else {
      fetchUserInfo();
      trackEvent(BRAND_PAGE_VISITED);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  return fetchUserLoading ? (
    <Loading />
  ) : (
    <Grid container sx={styles.root}>
      <Grid sx={styles.formContainer} item xs={12}>
        <Routes>
          <Route index element={<Navigate to="sign-up" replace />} />
          <Route
            path="sign-up"
            element={
              <BrandOnboardingSignup
                email={email}
                action={AuthAction.SIGN_UP}
              />
            }
          />
          <Route
            path="sign-in"
            element={
              <BrandOnboardingSignup
                email={email}
                action={AuthAction.SIGN_IN}
              />
            }
          />
        </Routes>
      </Grid>
    </Grid>
  );
};

export default BrandOnboardingFlow;
